<template>
  <v-container fluid class="p-content p-premium-properties fix-width">
    <v-row justify="center">
      <v-col class="col-md-11 col-12 px-3">
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center">
            <div class="d-flex justify-center align-center" style="gap: 20px">
              <v-btn class="darkblue--btn mb-0">Latest Blogs</v-btn>
              <v-btn color="primary" outlined to="/blogs" class="px-5">
                View All
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2 px-16">
      <v-col
        cols="12"
        md="4"
        v-for="(blog, index) in homeBlogs"
        :key="index"
        class="pa-3"
      >
        <BlogCard :post="blog" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import BlogCard from "@/components/BlogCard";

export default {
  name: "HomeBlogSection",
  components: {
    BlogCard,
  },
  computed: {
    ...mapState(["homeBlogs"]),
  },
  methods: {
    formatDate(dateString) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    navigateToBlog(slug) {
      this.$router.push({ name: "singleBlog", params: { slug } });
    },
  },
};
</script>

<style scoped>
/* No need for card styling as it's now handled by the BlogCard component */
</style>
